import React, { Component } from 'react';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { View, Image, ActivityIndicator} from "react-native-web";

import HeaderPC from '../../header/HeaderPC';
import HeaderMobile from '../../header/HeaderMobile';
import HeaderTablet from '../../header/HeaderTablet';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function LoadingPage() {




    return (

	         <div>


                  {!isMobileOnly && !isTablet &&
                    <BrowserView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', alignItems: 'center', backgroundColor: '#ecedf0'}}>

                        <HeaderPC />

                        <Image source={{uri: 'https://d3van47cb9u9tj.cloudfront.net/debyooid/cdpresse_logo_tag_fr.png'}} style={{width:'480px', height: '182px', marginBottom: '40px'}}/>



                        <ActivityIndicator  animating={true} color="#0079ff" />
                      </View>
                   </BrowserView>
                 }



                 {isMobileOnly &&
           			  <MobileView>
                    <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', alignItems: 'center', backgroundColor: '#ecedf0'}}>


                      <HeaderMobile />



                      <Image source={{uri: 'https://d3van47cb9u9tj.cloudfront.net/debyooid/cdpresse_logo_tag_fr.png'}} style={{width:'130px', height: '49px', marginBottom: '40px'}}/>



                      <ActivityIndicator  animating={true} color="#0079ff" />
                    </View>
           			 </MobileView>
           			}

           			{isTablet &&
           			  <TabletView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', alignItems: 'center', backgroundColor: '#ecedf0'}}>

                          <HeaderTablet />


                        <Image source={{uri: 'https://d3van47cb9u9tj.cloudfront.net/debyooid/cdpresse_logo_tag_fr.png'}} style={{width:'380px', height: '144px', marginBottom: '40px'}}/>




                        <ActivityIndicator  animating={true} color="#0079ff" />
                      </View>
           			  </TabletView>
           			}








	        </div>

    )

}
